import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLogout } from '../../../reducer/authentication';
import { API_URL } from '../../../config/constants';
import './Organization.scss';
import createIconImg from '../../../images/createIcon.png';
import { useBlocker, useNavigate } from 'react-router';
import NewOrgRow from './components/NewOrgRow';
import YouWereEditing from '../../components/YouWereEditing';

function Organization(props) {
    const { userRank, privilege, login } = useSelector((state) => state.session);
    const [origOrg, setOrigOrg] = useState([]);
    const [orgArr, setOrgArr] = useState([]);
    const [newRowsArr, setNewRowsArr] = useState([]);
    const [changed, setChanged] = useState(false);
    const navigate = useNavigate();
    async function getOrganizations() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getOrg`);
        setOrigOrg([...response.data]);
        setOrgArr(response.data);
    }
    console.log(orgArr)
    const onCreateNewRow = e => {

        setNewRowsArr(prev => [...prev, {
            name: '',
            nameEng: '',
            nameIncharge: '',
            telIncharge: '',
            mailIncharge: '',
            topicOrg: '',
            comment: ''
        }]);
        setChanged(true);
    }

    const onChangeNew = (e, nrIdx) => {
        let copyArr = [...newRowsArr];
        copyArr[nrIdx] = { ...copyArr[nrIdx], [e.target.name]: e.target.value };
        setNewRowsArr(copyArr);
    };

    const handleCreateObject = async e => {
        e.preventDefault();
        // 수정 사항 id(PK)체크 후 해당 데이터만 전송
        if (newRowsArr.length > 0 && newRowsArr.some(function (x) {
            return x.name.length === 0 || x.nameEng.length === 0;
        })) {
            window.alert('새 조직 중 이름 혹은 영문명을 입력하지 않은 것이 있습니다.');
            return;
        }
        const updatedData = orgArr.filter(x => !origOrg.includes(x));
        await axios.post(`${API_URL}/monitoring-manage/updateOrganization`, { updatedData: updatedData, newData: newRowsArr }).then(res => {
            if (res.data.success) {
                // window.location = '/model/edit';
                navigate(0);
                // onReturnDefault(e);
            } else {
                console.error(res.data.error);
            }
        }).catch(err => console.error(err));

    };

    const onReset = e => {
        e.preventDefault();
        setOrgArr([...origOrg]);
        setNewRowsArr([]);
        setChanged(false);
    };

    const onChange = (e, rowIdx) => {
        let copiedArr = [...orgArr];
        copiedArr[rowIdx] = { ...copiedArr[rowIdx], [e.target.name]: e.target.value };
        setOrgArr(copiedArr);
        setChanged(true);
    }

    const dispatch = useDispatch();
    const onLogout = () => dispatch(setLogout());
    useEffect(() => {
        if (userRank > 10) {
            onLogout();
        }
    }, [userRank]);
    useEffect(() => {
        getOrganizations();
    }, []);

    const [blockPopup, setBlockPopup] = useState(false);
    let blocker = useBlocker(({ currentLocation, nextLocation }) =>
        changed && login &&
        currentLocation.pathname !== nextLocation.pathname);

    useEffect(() => {
        if (blocker.state === "blocked") {
            setBlockPopup(true);
        } else {
            setBlockPopup(false);
        }
    }, [blocker.state])
    return (
        <React.Fragment>
            <div className='organizationArea'>
                <p className='path'>데이터 구조 관리<span className='below'>{'>'}</span>조직</p>
                <h2 className='pageTitle'>조직</h2>
                <div className='organizationTblArea'>
                    <ul className='organizationTbl'>
                        <li className='row th'>
                            <ul>
                                <li className='col name'>조직</li>
                                <li className='col nameEng'>영문명</li>
                                <li className='col nameIncharge'>담당자</li>
                                <li className='col telIncharge'>담당자 연락처</li>
                                <li className='col mailIncharge'>담당자 이메일</li>
                                <li className='col topicOrg'>MQTT 토픽명</li>
                                <li className='col comment'>코멘트</li>
                            </ul>
                        </li>
                        {
                            orgArr.map((orgData, index) => {
                                return (
                                    <li key={`orgTr_${index}`} className='row'>

                                        <ul>
                                            <li className='col name'>
                                                <div className='inputArea'>
                                                    <input name={"name"} value={orgData.name} onChange={e => onChange(e, index)} />
                                                </div>
                                            </li>
                                            <li className='col nameEng'>
                                                <div className='inputArea'>
                                                    <input name={"nameEng"} value={orgData.nameEng} onChange={e => onChange(e, index)} />
                                                </div>
                                            </li>
                                            <li className='col nameIncharge'>
                                                <div className='inputArea'>
                                                    <input name={"nameIncharge"} value={orgData.nameIncharge ?? ''} onChange={e => onChange(e, index)} />
                                                </div>
                                            </li>
                                            <li className='col telIncharge'>
                                                <div className='inputArea'>
                                                    <input name={"telIncharge"} value={orgData.telIncharge ?? ''} onChange={e => onChange(e, index)} />
                                                </div>
                                            </li>
                                            <li className='col mailIncharge'>
                                                <div className='inputArea'>
                                                    <input name={"mailIncharge"} value={orgData.mailIncharge ?? ''} onChange={e => onChange(e, index)} />
                                                </div>
                                            </li>
                                            <li className='col topicOrg'>
                                                <div className='inputArea'>
                                                    <input name={"topicOrg"} value={orgData.topicOrg ?? ''} onChange={e => onChange(e, index)} />
                                                </div>
                                            </li>
                                            <li className='col comment'>
                                                <div className='inputArea'>
                                                    <input name={"comment"} value={orgData.comment ?? ''} onChange={e => onChange(e, index)} />
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                );
                            })
                        }
                        {
                            newRowsArr.map((newRow, nrIdx) => (<NewOrgRow
                                newRow={newRow}
                                nrIdx={nrIdx}
                                onChangeNew={onChangeNew}
                                key={`newOrgTr_${nrIdx}`}
                            />))
                        }
                    </ul>

                </div>
                {
                    <div className='btnsArea cscBtns'>
                        <button className={'createBtn'} onClick={onCreateNewRow}>추가<img src={createIconImg} alt={"추가"} /></button>
                        <button className='editBtn' onClick={handleCreateObject} disabled={!changed}>저장</button>
                        <button className='cancelBtn' onClick={onReset} disabled={!changed}>취소</button>
                    </div>
                }
            </div>
            <YouWereEditing
                isOpen={blockPopup}
                onRequestClose={e => { e.preventDefault(); blocker.reset(); }}
                onSubmit={e => { e.preventDefault(); blocker.proceed(); }}
            />
        </React.Fragment>
    );
}

export default Organization;